/*eslint-disable import/default, import/namespace, import/no-named-as-default, import/no-named-as-default-member */
import React from 'react';
import logo from '../../images/logo.svg';
import loadingSentences from '../../data/loading.json';

class LoadingStep extends React.Component {
  render() {
    const {counter} = this.props;
    const sentence = loadingSentences[counter];
    const className = 'loading is-sentences-' + loadingSentences.length + ' is-sentence-' + (counter+1);
    return (
      <div className={className}>
        <div className="loading__container">
          <div className="loading__logo"><img src={logo} /></div>
          <div className="loading__sentences">
            <ul className="loading__sentences__list">
              {loadingSentences.map((sentence, index) => (
                <li className="loading__sentences__item" key={index}>{sentence}</li>
              ))}
            </ul>
          </div>
        </div>
        <div className="search__intro__during__loading">
          <p className="intro-text-paragraph"><strong>Testmysite.io rates your site based on its initial global load times and its security settings.</strong></p>
          <p className="intro-text-paragraph">Even a very optimized site made on a legacy stack like Wordpress can often become several seconds faster by being built in a modern way and served via a service such as Netlify. By using HTTPS and HTTP2 you can improve both speed and search ranking.</p>
        </div>
      </div>
    );
  }
}

LoadingStep.propTypes = {
  sentences: React.PropTypes.array,
  currentSentence: React.PropTypes.number,
};

export default LoadingStep;



// WEBPACK FOOTER //
// ./src/components/loading/LoadingStep.js